import React, { Component } from "react";
import { RangeInput } from "@appbaseio/reactivesearch";
import RangeFilterWithSelect from "./RangeFilterWithSelect";

class RetailPriceRange extends Component {
  constructor(props) {
    super(props);
    this.handleSelected = this.handleSelected.bind(this);
  }

  handleSelected(value) {
    // console.log("value : ", value);
    if (value.start === 0 && value.end === 10000000) {
      // console.log("firsttime load");
      return;
    } else {
      // console.log("Inside Handle Selected");
      this.props.showSelectedResults(true);
    }
  }

  render() {
    let { appType } = this.props;
    return (
      <div className="price-range">
        <RangeInput
          className="price-range__input"
          innerClass={{
            "slider-container": "price-slider-container",
            "input-container": "price-range__input--price-input",
          }}
          title={appType && appType === "customer" ? "Retail Price" : "Retail"}
          componentId="RetailPriceRange"
          dataField={"RetailPrice"}
          showSlider={false}
          range={{
            start: 0,
            end: 10000000,
          }}
          customQuery={function(value, props) {
            if (value[0] === 0 && value[1] === 10000000) {
              // console.log("all query")
              return {
                query: {
                  match_all: {},
                },
              };
            } else {
              // console.log("range query")
              return {
                query: {
                  range: {
                    RetailPrice: { gte: value[0], lte: value[1], boost: 2 },
                  },
                },
              };
            }
          }}
          rangeLabels={{
            start: "$",
            end: "$",
          }}
          onValueChange={(value) => this.handleSelected(value)}
        />
      </div>
    );
  }
}
export default RangeFilterWithSelect(RetailPriceRange);
